export enum CatalogCardVariantKey {
  SMALL = 'small',
  MEDIUM = 'medium',
  LARGE = 'large',
}

export type CatalogCardBreakpoint = 'xs' | 'sm' | 'md' | 'lg' | 'xl';

export type CatalogColumnsByVariant = Record<CatalogCardVariantKey, number>;

export interface GetCatalogCardColumnsParams {
  breakpoint: CatalogCardBreakpoint;
  openPanelsCount: number;
  variant: CatalogCardVariantKey;
}
